import clsx from 'clsx';
import { ReactNode } from 'react';

interface Props {
  actions?: ReactNode;
  children?: ReactNode;
  className?: string;
  noPadding?: boolean;
  text?: string | null;
  /**
   * The text size used for the header. sm: text-l md: text-xl lg: text-2xl
   */
  size?: 'sm' | 'md' | 'lg';
  startIcon?: ReactNode;
  [x: string]: any;
}

export const CardHeader = ({
  actions,
  children = null,
  className,
  noPadding = false,
  rest,
  startIcon = null,
  size = 'lg',
  text = null,
}: Props) => {
  const classes = useStyles(noPadding);

  if (!children && !text)
    throw new Error('CardHeader must have either a text property or children');

  const renderStartIcon = () => {
    if (!startIcon) return;
    return <span className={clsx()}>{startIcon}</span>;
  };

  const renderActions = () => {
    if (!actions) return;
    return <div className={clsx(classes.actions)}>{actions}</div>;
  };

  const renderHeader = () => {
    if (!children && text)
      return (
        <h2 className={clsx(classes.header.default, classes.header.size[size])}>
          {text}
        </h2>
      );
    else if ((children && !text) || (children && text)) return children;
  };

  return (
    <div
      className={clsx(
        className,
        classes.container.default,
        classes.container.padding
      )}
      {...rest}
    >
      {renderStartIcon()}
      {renderHeader()}
      {renderActions()}
    </div>
  );
};

const useStyles = (noPadding: boolean) => {
  const padding = noPadding ? 'p-0' : 'pt-2 px-4 pb-1';
  return {
    actions: 'inline-flex flex-nowrap gap-2',
    container: {
      default:
        'inline-flex text-neutral-700 dark:text-white items-center gap-2',
      padding: padding,
    },
    header: {
      default: 'inline-flex',
      size: {
        sm: 'text-lg',
        md: 'text-xl',
        lg: 'text-2xl',
      },
    },
  };
};
